import React, { useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import {
  FaBolt,
  FaChartBar,
  FaUserShield,
  FaSmile,
  FaMoneyCheckAlt
} from 'react-icons/fa';

import 'swiper/css';
import './loan-features.css';

const features = [
  {
    icon: <FaBolt size={50} color="#052daa" />,
    title: 'Instant Approval',
    desc: 'Swift approvals with minimal documentation.'
  },
  {
    icon: <FaChartBar size={50} color="#052daa" />,
    title: 'Affordable Rates',
    desc: 'Competitive interest customized for you.'
  },
  {
    icon: <FaUserShield size={50} color="#052daa" />,
    title: 'Secure Process',
    desc: 'Your data is fully secured.'
  },
  {
    icon: <FaSmile size={50} color="#052daa" />,
    title: 'Customer Support',
    desc: '24/7 assistance for all your loan needs.'
  },
  {
    icon: <FaMoneyCheckAlt size={50} color="#052daa" />,
    title: 'Quick Disbursement',
    desc: 'Funds are transferred promptly post-approval.'
  }
];

const LoanFeatures = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.start();
    }
  }, []);

  return (
    <section className="lf-section py-5 bg-light pb-0">
      <div className="container text-center">
        <h2 className="lf-title mb-4">Personal Loan Features</h2>

        <Swiper
          modules={[Autoplay]}
          slidesPerView="auto"
          spaceBetween={30}
          loop={true}
          speed={2000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          onSwiper={(swiper) => {
            swiper.wrapperEl.style.transitionTimingFunction = 'linear';
            swiperRef.current = swiper;
          }}
        >
          {[...features, ...features].map((f, idx) => (
            <SwiperSlide key={idx} className="lf-slide">
              <div className="lf-card d-flex flex-column align-items-center p-4 bg-white rounded">
                {f.icon}
                <h5 className="lf-card-title mt-2 mb-1">{f.title}</h5>
                <p className="lf-card-desc mb-0">{f.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default LoanFeatures;
